import { Canvas } from './canvas.js';
import { Tools } from './tools.js';
import { PaletteUI } from './palette-ui.js';
import { Modal } from './modal.js';
import { WelcomeModal } from './welcomeModal.js';
import { vgaPalette, STARTING_COLOR } from './palette.js';

export class PixelEditor {
  constructor() {
    this.appContainer = document.getElementById('app');
    this.canvas = new Canvas(30);
    this.tools = new Tools();
    this.paletteUI = new PaletteUI((colorIndex) => {
      this.setActiveColor(colorIndex);
    });
    this.modal = new Modal();
    this.welcomeModal = new WelcomeModal();
    
    this.setupEventListeners();
    this.initialize();
  }

  setActiveColor(colorIndex) {
    this.tools.setActiveColor(colorIndex);
    this.paletteUI.setActiveColor(colorIndex);
    this.appContainer.style.backgroundColor = vgaPalette[colorIndex];
  }

  setupEventListeners() {
    // Canvas drawing events
    this.canvas.element.addEventListener('click', (e) => this.handleCanvasClick(e));
    this.canvas.element.addEventListener('mousedown', (e) => this.handleCanvasMouseDown(e));
    this.canvas.element.addEventListener('mousemove', (e) => this.handleCanvasMouseMove(e));
    this.canvas.element.addEventListener('mouseup', () => this.handleCanvasMouseUp());
    this.canvas.element.addEventListener('mouseleave', () => this.handleCanvasMouseUp());

    // Menu buttons
    document.getElementById('clearBtn').addEventListener('click', () => this.clearCanvas());
    document.getElementById('saveBtn').addEventListener('click', () => this.saveCanvas());
  }

  initialize() {
    this.tools.render();
    this.paletteUI.render();
    this.canvas.render();
    this.setActiveColor(STARTING_COLOR);
  }

  handleCanvasClick(e) {
    const pixel = e.target.closest('.pixel');
    if (!pixel) return;
    
    const row = parseInt(pixel.dataset.row);
    const col = parseInt(pixel.dataset.col);
    const activeTool = this.tools.getActiveTool();
    const activeColor = this.tools.getActiveColor();

    if (activeTool === 'brush') {
      this.canvas.setPixel(row, col, activeColor);
    } else if (activeTool === 'eraser') {
      this.canvas.setPixel(row, col, null);
    } else if (activeTool === 'dropper') {
      const val = this.canvas.getPixel(row, col);
      if (val !== null) {
        this.setActiveColor(val);
      }
    }
    
    this.canvas.render();
  }

  handleCanvasMouseDown(e) {
    this.canvas.isDrawing = true;
    this.handleCanvasClick(e);
  }

  handleCanvasMouseMove(e) {
    if (!this.canvas.isDrawing) return;
    this.handleCanvasClick(e);
  }

  handleCanvasMouseUp() {
    this.canvas.isDrawing = false;
  }

  clearCanvas() {
    this.canvas.clear();
    this.tools.reset();
    this.setActiveColor(STARTING_COLOR);
  }

  saveCanvas() {
    const svg = this.canvas.generateSVG();
    this.modal.show(svg);
  }
} 